export const SET_OPEN_POPUP_SIGN_UP = 'set_open_popup_sign_up'
export const SET_PACKAGE_ID = 'set_package_id'
export const SET_IS_LOGIN = 'set_is_login'
export const SET_DARK_MODE = 'set_dark_mode'
